export const NOTIFICATION_TO_COMMUNITY = `
  mutation notificationToCommunity($message: String!) {
    notificationToCommunity(message: $message)
  }
`;

export const NOTIFICATION_TO_USER = `
  mutation notificationToUser($input: NotificationToUserInput!) {
    notificationToUser(input: $input)
  }
`;

export const NOTIFICATIONS_READ = `
  mutation notificationsRead {
    notificationsRead
  }
`;

export const NOTIFICATION_SEEN = `
  mutation notificationSeen($id: ID!) {
    notificationSeen(id: $id)
  }
`;
